<h5 md-dialog-title id="modal-title" *ngIf="!data">Nuevo Rol</h5>
<h5 md-dialog-title id="modal-title" *ngIf="data">Editar Rol</h5>
<mat-dialog-content>
    <form [formGroup]="form" class="formulario" autocomplete="off">
        <mat-form-field>
            <input matInput placeholder="Nombre"
                formControlName="nombre"
                required>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="secondary" mat-dialog-close>Cancelar</button>
    <button mat-raised-button class="primary" (click)="guardar()" *ngIf="!data">Guardar</button>
    <button mat-raised-button class="primary" (click)="actualizar()" *ngIf="data">Actualizar</button>
</mat-dialog-actions>